/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  NotificationsDispatchPublicControllerResolveBonusLinkQueryResponse,
  NotificationsDispatchPublicControllerResolveBonusLinkPathParams,
  NotificationsDispatchPublicControllerResolveBonusLink404,
} from '../types/NotificationsDispatchPublicControllerResolveBonusLink.ts';

function getNotificationsDispatchPublicResolveBonusLinkUrl(
  code: NotificationsDispatchPublicControllerResolveBonusLinkPathParams['code'],
) {
  const res = { method: 'GET', url: `/api/telegram/notifications/bonus-links/${code}` as const };
  return res;
}

/**
 * {@link /api/telegram/notifications/bonus-links/:code}
 */
export async function notificationsDispatchPublicResolveBonusLink(
  code: NotificationsDispatchPublicControllerResolveBonusLinkPathParams['code'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    NotificationsDispatchPublicControllerResolveBonusLinkQueryResponse,
    ResponseErrorConfig<NotificationsDispatchPublicControllerResolveBonusLink404>,
    unknown
  >({ method: 'GET', url: getNotificationsDispatchPublicResolveBonusLinkUrl(code).url.toString(), ...requestConfig });
  return res.data;
}
